/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectprioritiesIdQueryResponse,
  GetApiProjectprioritiesIdPathParams,
} from '../models/GetApiProjectprioritiesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectprioritiesIdQueryResponseSchema } from '../zod/getApiProjectprioritiesIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectprioritiesIdQueryKey = (
  id: GetApiProjectprioritiesIdPathParams['id'],
) => [{ url: '/api/projectpriorities/:id', params: { id: id } }] as const;

export type GetApiProjectprioritiesIdQueryKey = ReturnType<
  typeof getApiProjectprioritiesIdQueryKey
>;

/**
 * {@link /api/projectpriorities/:id}
 */
export async function getApiProjectprioritiesId(
  id: GetApiProjectprioritiesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectprioritiesIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/projectpriorities/${id}`,
    ...requestConfig,
  });
  return getApiProjectprioritiesIdQueryResponseSchema.parse(res.data);
}

export function getApiProjectprioritiesIdQueryOptions(
  id: GetApiProjectprioritiesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectprioritiesIdQueryKey(id);
  return queryOptions<
    GetApiProjectprioritiesIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectprioritiesIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjectprioritiesId(id, config);
    },
  });
}

/**
 * {@link /api/projectpriorities/:id}
 */
export function useGetApiProjectprioritiesId<
  TData = GetApiProjectprioritiesIdQueryResponse,
  TQueryData = GetApiProjectprioritiesIdQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectprioritiesIdQueryKey,
>(
  id: GetApiProjectprioritiesIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectprioritiesIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiProjectprioritiesIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiProjectprioritiesIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
